import { store } from 'index'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'

interface ApiRequestParams {
  url: string
  apiMethod: string
  data?: any
  headers?: Record<string, string>
}

export const useApiRequest = () => {
  return async <T = any>({
    url,
    apiMethod,
    data,
    headers = {},
  }: ApiRequestParams): Promise<T> => {
    const requestOptions: RequestInit = {
      method: apiMethod,
      headers: {
        ...apiHeaders(store.getState()),
        'Content-Type': 'application/json',
        ...headers,
      },
    }

    if (
      data &&
      (apiMethod === API_METHODS.POST || apiMethod === API_METHODS.PUT)
    ) {
      requestOptions.body = JSON.stringify(data)
    }

    const response = await fetch(url, requestOptions)

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}))
      const errorMessage =
        errorData.error?.messages?.[0] ||
        errorData.error?.message ||
        errorData.message ||
        `Request failed with status ${response.status}`
      throw new Error(errorMessage)
    }

    return response.json()
  }
}
